var _path, _path2, _path3, _rect, _path4, _rect2, _rect3, _circle, _rect4, _circle2, _rect5, _circle3, _rect6, _rect7, _path5, _circle4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgErrorGeneral(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 340 201",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M95 200h150",
    stroke: "#627A92",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3 30h335",
    stroke: "#E0E4E9",
    strokeWidth: 2,
    strokeLinecap: "square"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M145 199v-16",
    stroke: "#627A92",
    strokeWidth: 2,
    strokeLinecap: "square"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 338,
    height: 181,
    rx: 7,
    stroke: "#627A92",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M195 199v-16",
    stroke: "#627A92",
    strokeWidth: 2,
    strokeLinecap: "square"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 8,
    width: 16,
    height: 16,
    rx: 2,
    fill: "#E0E4E9"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 55,
    y: 11,
    width: 34,
    height: 9,
    rx: 4.5,
    fill: "#E0E4E9"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 46.5,
    cy: 15.5,
    r: 4.5,
    fill: "#E0E4E9"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 126,
    y: 11,
    width: 34,
    height: 9,
    rx: 4.5,
    fill: "#E0E4E9"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 117.5,
    cy: 15.5,
    r: 4.5,
    fill: "#E0E4E9"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 197,
    y: 11,
    width: 34,
    height: 9,
    rx: 4.5,
    fill: "#E0E4E9"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 188.5,
    cy: 15.5,
    r: 4.5,
    fill: "#E0E4E9"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 137,
    y: 63,
    width: 66,
    height: 66,
    rx: 7,
    fill: "#fff",
    stroke: "#627A92",
    strokeWidth: 2
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 151,
    y: 77,
    width: 38,
    height: 38,
    rx: 5,
    fill: "#C72D2D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M170 84v14",
    stroke: "#fff",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 170,
    cy: 106,
    r: 3,
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorGeneral);
export default __webpack_public_path__ + "static/media/errorGeneral.6300122cdf3d14a4b701ffb758c86b00.svg";
export { ForwardRef as ReactComponent };